import React from "react";

type PriceInputProps = {
    value: string;
    onChange: (value: string) => void;
};

const PriceInput: React.FC<PriceInputProps> = ({value, onChange}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value;

        // Replace commas with dots
        input = input.replace(/,/g, ".");

        // Keep only numbers and dots
        input = input.replace(/[^0-9.]/g, "");

        // Allow only one dot
        const parts = input.split(".");
        if (parts.length > 2) {
            input = parts[0] + "." + parts.slice(1).join("");
        }

        onChange(input);
    };

    return (
        <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="Ammontare*"
            className="border rounded px-3 py-2 w-full"
        />
    );
};

export default PriceInput;